import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';

import {
  DomSanitizer,
  SafeResourceUrl
} from '@angular/platform-browser';

import { SiteSettingsService } from '../../services/site-setting.service';

@Component({
  selector: 'app-youtube-feature',
  standalone: true,
  templateUrl: './youtube-feature.component.html',
  styleUrls: ['./youtube-feature.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class YoutubeFeatureComponent implements OnInit {

  youtubeUrl = '';
  youtubeVideoId: string | null = null;
  youtubeEmbedUrl: SafeResourceUrl | null = null;

  constructor(
    private readonly siteSettingsService: SiteSettingsService,
    private readonly sanitizer: DomSanitizer,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadYouTube();
  }

  loadYouTube(): void {
    this.siteSettingsService
      .getYouTube()
      .subscribe({
        next: response => {
          this.youtubeUrl = response.youtubeUrl;

          this.setYouTubeVideo(this.youtubeUrl);

          this.changeDetector.markForCheck();
        },

        error: error => {
          console.error(
            'Unable to load YouTube video:',
            error
          );

          this.youtubeVideoId = null;
          this.youtubeEmbedUrl = null;

          this.changeDetector.markForCheck();
        }
      });
  }

  private setYouTubeVideo(url: string): void {
    const videoId = this.extractYouTubeId(url);

    if (!videoId) {
      this.youtubeVideoId = null;
      this.youtubeEmbedUrl = null;
      return;
    }

    this.youtubeVideoId = videoId;

    this.youtubeEmbedUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${videoId}`
      );
  }

  private extractYouTubeId(url: string): string | null {
    if (!url) {
      return null;
    }

    try {
      const parsedUrl = new URL(url.trim());

      // https://youtu.be/VIDEO_ID
      if (parsedUrl.hostname === 'youtu.be') {
        return parsedUrl.pathname
          .replace('/', '')
          .split('/')[0] || null;
      }

      // https://youtube.com/watch?v=VIDEO_ID
      const watchId = parsedUrl.searchParams.get('v');

      if (watchId) {
        return watchId;
      }

      // https://youtube.com/embed/VIDEO_ID
      // https://youtube.com/shorts/VIDEO_ID
      const parts = parsedUrl.pathname
        .split('/')
        .filter(Boolean);

      const embedIndex = parts.indexOf('embed');

      if (embedIndex !== -1 && parts[embedIndex + 1]) {
        return parts[embedIndex + 1];
      }

      const shortsIndex = parts.indexOf('shorts');

      if (shortsIndex !== -1 && parts[shortsIndex + 1]) {
        return parts[shortsIndex + 1];
      }

      return null;
    } catch {
      return null;
    }
  }
}